import React from "react";
import './HeroHeading.css'

const HeroHeading = () => {
    return (
        <div className="HeroHeading">
            <div>
            <span className="stoke-text" >fit </span> 
            <span>your </span>
            <span>needs</span></div>

            <div>
                <span>As </span>
                <span className="stoke-text">fit </span>
                <span>as you can</span>
            </div>

            <div><span className="slogan">We understand diverity, that's why</span></div>
        </div>

       
    )
}

export default HeroHeading